import React, {useContext} from 'react';
import {Route, Routes} from 'react-router-dom'
import {authRoutes, publicRoutes} from "../routes";
import {Context} from "../index";
import {observer} from "mobx-react-lite";
const AppRouter = observer(() => {
    const {staff} = useContext(Context);
    return (
        <Routes>
            {publicRoutes.map(({link, Component}) =>{
                return (
                    <Route key={link} path={link} element={Component}/>
                )
            }
            )}
            {staff.isAuth && authRoutes.map(({link, Component}) =>
                <Route key={link} path={link} element={Component}/>
            )}
        </Routes>
    );
});

export default AppRouter;